import { useState } from "react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";
import { Field, Card } from "@/components/checkout/Field";

export const AdminSecurity = () => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const save = async () => {
    if (!/^\d{4}$/.test(next)) return toast.error("El nuevo PIN debe tener 4 dígitos");
    try {
      await http.put("/admin/pin", { current_pin: cur, new_pin: next });
      toast.success("PIN actualizado");
      setCur(""); setNext("");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const digits = (fn) => (e) => fn(e.target.value.replace(/\D/g, "").slice(0, 4));
  return (
    <Card title="Cambiar PIN de acceso">
      <Field label="PIN actual" type="password" inputMode="numeric" value={cur} onChange={digits(setCur)} testid="pin-current-input" />
      <Field label="Nuevo PIN (4 dígitos)" type="password" inputMode="numeric" value={next} onChange={digits(setNext)} testid="pin-new-input" />
      <button onClick={save} className="w-full py-3 rounded-full bg-[#DC2626] hover:bg-[#991B1B] text-white font-bold" data-testid="pin-save-btn">Actualizar PIN</button>
    </Card>
  );
};
